import { canonicalMagPeriod } from './kkpMagPeriodUtils';

/** Mois calendaire courant (sans règle CDF / butoir — préférer meta.default_period pour MAG/SET/CDF). */
export const getKkpDefaultPeriod = (date = new Date()) => {
  const baseDate = new Date(date);

  return {
    annee: baseDate.getFullYear(),
    mois: baseDate.getMonth() + 1,
  };
};

export const getKkpDefaultMagPeriod = (date = new Date()) => {
  const period = getKkpDefaultPeriod(date);

  return canonicalMagPeriod(period.annee, period.mois);
};
